firebird
    .directive('sidebarLeft', [
        'templateCache',
        'helperService',
        function (templateCache, helperService) {
            return {
                restrict: 'E',
                template: templateCache.getTemplate(helperService.getRedesignPathPrefix() + 'sidebar-left.html')
            };
        }
    ])
    .directive('toggleSidebar', function () {
        return {
            restrict: 'A',
            scope: {
                modelLeft: '=',
                modelRight: '='
            },
            link: function (scope, element, attr) {
                element.on('click', function () {
                    if (element.data('target') === 'left') {
                        scope.$apply(function () {
                            scope.modelLeft = !scope.modelLeft;
                        });
                    }

                    if (element.data('target') === 'right') {
                        scope.$apply(function () {
                            scope.modelRight = !scope.modelRight;
                        });
                    }
                });
            }
        };
    });
